export const SUB_MENU_TYPE_REQUEST = 'SUB_MENU_TYPE_REQUEST';
export const SUB_MENU_TYPE_SUCCESS = 'SUB_MENU_TYPE_SUCCESS';
export const SUB_MENU_TYPE_FAIL = 'SUB_MENU_TYPE_FAIL';

